/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_Column_Not_EmptyInputs */

const en_error_email_column_not_empty = /** @type {(inputs: Error_Email_Column_Not_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The column has blocks: move or remove them before taking it away.`)
};

/**
* | output |
* | --- |
* | "The column has blocks: move or remove them before taking it away." |
*
* @param {Error_Email_Column_Not_EmptyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_email_column_not_empty = /** @type {((inputs?: Error_Email_Column_Not_EmptyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_Column_Not_EmptyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_email_column_not_empty(inputs)
});